/* eslint-disable no-underscore-dangle */
/* eslint-disable no-plusplus */
import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import EsrrSprTimelineItem from './EsrrSprTimelineItem';
import { EsrrSprTimelineContainer } from '../../../../services/types/EsrrSprTimeline';

interface Props {
  data: EsrrSprTimelineContainer;
  timelineWidth: number;
}

const EsrrSprTimelineWrapper = (props: Props) => {
  const { data, timelineWidth } = props;
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const timelineRef = useRef<HTMLDivElement>(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const getRecordsWitdth = () => data.records.length * 180;

  const getMaxScroll = () => {
    if (timelineRef.current) {
      return getRecordsWitdth() - timelineRef.current.clientWidth;
    }
    return 0;
  };
  const scrollTo = (direction: 'left' | 'right') => {
    if (timelineRef.current) {
      const maxScroll = getMaxScroll();
      let offset = scrollPosition + (direction === 'left' ? -1 : 1) * 500;
      if (offset > maxScroll) {
        offset = maxScroll;
      }
      if (offset < 0) {
        offset = 0;
      }
      timelineRef.current.scrollTo({
        left: offset,
        behavior: 'smooth',
      });
      setScrollPosition(offset);
    }
  };

  const getBorderWidth = () => {
    const scrollwidth = 79;

    if (containerRef.current && containerRef.current.clientWidth - scrollwidth < timelineWidth) {
      return `${containerRef.current.clientWidth - scrollwidth}px`;
    }

    return `${timelineWidth}px`;
  };

  useEffect(() => {
    const maxScroll = getMaxScroll();

    if (timelineRef.current) {
      timelineRef.current.scrollTo({
        left: maxScroll,
        behavior: 'smooth',
      });

      setScrollPosition(maxScroll);
    }
  }, []);

  return (
    <div className="esrr-spr-timeline">
      <h5 className="title">{t('ESRR/SPR Timeline')}</h5>
      <div className="esrr-spr-timeline-container" ref={containerRef}>
        <div className="esrr-spr-timeline-headers-container">
          <div className="scroll-button-container-left">
            {timelineRef.current && getRecordsWitdth() > timelineRef.current.clientWidth && (
              <Button
                id="left-scroll"
                className="btn-tertiary scroll-button"
                onClick={() => {
                  scrollTo('left');
                }}
                color="nothing"
                disabled={scrollPosition <= 0}
                type="button"
                active={false}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon icon={faAngleLeft} />
                </div>
              </Button>
            )}
          </div>
          <div className="esrr-spr-timeline-headers">
            <h5>{t('esrr')}</h5>
            <h5>{t('spr')}</h5>
          </div>
        </div>
        <div
          className="esrr-spr-timeline-wrapper"
          style={{ width: `${timelineWidth}px` }}
          ref={timelineRef}
        >
          <div className="esrr-spr-timeline-wrapper-border" style={{ width: getBorderWidth() }} />
          {data.records.map((record, i) => (
            <EsrrSprTimelineItem
              record={record}
              key={`esrrSprTimelineItem${i.toString()}`}
              className={i === 0 ? 'first' : ''}
            />
          ))}
        </div>
        <div className="scroll-button-container-right">
          {timelineRef.current && getRecordsWitdth() > timelineRef.current.clientWidth && (
            <Button
              id="right-scroll"
              className="btn-tertiary scroll-button"
              onClick={() => {
                scrollTo('right');
              }}
              color="nothing"
              disabled={scrollPosition >= getMaxScroll()}
              type="button"
              active={false}
            >
              <div className="d-flex align-items-center justify-content-center">
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EsrrSprTimelineWrapper;
